<template>
  <div class="car-number-container">
    <div class="car-number-list" :style="getContainerStyle()">
      <p
        :class="[options.theme, 'car-number-item', 'add-event-listener']"
        :style="getStyle(index, current)"
        v-for="(item, index) in getCarNumber"
        :key="index"
        @click="handleToggle(index)"
      >
        <span
          :style="{
            'font-size':
              index === 7 && lastText === '新能源'
                ? options.newEnergyFontSize + 'px'
                : options.textSize + 'px',
          }"
          >{{ index === 7 ? lastText : item }}</span
        >
      </p>
    </div>

    <transition name="el-zoom-in-bottom">
      <div
        :ref="`keyboardRef${model}`"
        class="keyboard-container add-event-listener"
        v-show="visible"
        :style="{ width: formWidth + 'px' }"
      >
        <el-header class="add-event-listener">
          <span
            class="add-event-listener"
            style="cursor: pointer"
            @click="handleReset"
            >重置</span
          >
          <span
            class="add-event-listener"
            style="cursor: pointer"
            @click="handleClose"
            >关闭</span
          >
        </el-header>
        <div class="keyboard-body add-event-listener">
          <template v-if="isArea">
            <ul
              class="keyboard-body-province-list add-event-listener"
              style="column-count: 10"
            >
              <li
                class="button add-event-listener"
                v-for="(areaItem, areaIndex) in areaOptions"
                :key="areaIndex"
                @click="handleSelect(areaItem)"
              >
                {{ areaItem }}
              </li>
            </ul>
          </template>

          <template v-else>
            <ul
              class="keyboard-body-province-list add-event-listener"
              :style="{ 'column-count': areaDigit.length }"
            >
              <li
                class="button add-event-listener"
                v-for="(areaDigitItem, areaDigitIndex) in areaDigit"
                :key="areaDigitIndex"
                @click="handleSelect(areaDigitItem)"
              >
                {{ areaDigitItem }}
              </li>
            </ul>
            <ul
              class="keyboard-body-province-list add-event-listener"
              :style="{ 'column-count': areaLetterOptions1.length }"
            >
              <li
                :class="[
                  'button',
                  'add-event-listener',
                  ['O', 'I'].indexOf(letterItem1) > -1 ? 'disabled' : '',
                ]"
                v-for="(letterItem1, letterIndex1) in areaLetterOptions1"
                :key="letterIndex1"
                @click="handleSelect(letterItem1)"
              >
                {{ letterItem1 }}
              </li>
            </ul>
            <ul
              class="keyboard-body-province-list add-event-listener"
              :style="{
                'column-count': areaLetterOptions2.length,
                padding: '0 4%',
              }"
            >
              <li
                class="button add-event-listener"
                v-for="(letterItem2, letterIndex2) in areaLetterOptions2"
                :key="letterIndex2"
                @click="handleSelect(letterItem2)"
              >
                {{ letterItem2 }}
              </li>
            </ul>
          </template>

          <div class="keyboard-body-bottom add-event-listener">
            <div
              class="other-button add-event-listener"
              @click="isArea = !isArea"
            >
              <span class="add-event-listener">{{
                isArea ? 'ABC' : '地区'
              }}</span>
            </div>
            <ul
              class="keyboard-body-bottom-item-list add-event-listener"
              :style="{ 'column-count': getLastOptions.length }"
            >
              <li
                class="button add-event-listener"
                v-for="(lastItem, lastIndex) in getLastOptions"
                :key="lastIndex"
                @click="handleSelect(lastItem)"
              >
                {{ lastItem }}
              </li>
            </ul>
            <div class="other-button add-event-listener" @click="handleDelete">
              <i class="el-icon-close add-event-listener"></i>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import {
  areaOptions,
  areaBottomOptions,
  areaLetterOptions1,
  areaLetterOptions2,
  areaLetterOptions3,
  areaDigit,
} from './data'
export default {
  name: 'carNumber',
  props: ['options', 'value', 'disabled', 'model'],
  data() {
    return {
      areaOptions: areaOptions,
      areaBottomOptions: areaBottomOptions,
      areaLetterOptions1: areaLetterOptions1,
      areaLetterOptions2: areaLetterOptions2,
      areaLetterOptions3: areaLetterOptions3,
      areaDigit: areaDigit,
      visible: false, // 键盘弹出
      current: !this.disabled ? 0 : -1, // 当前激活索引
      isArea: true,
      getCarNumber: ['', '', '', '', '', '', '', ''],
      carNumberMaxLength: 8, // 车牌最大长度
      globalClickListeners: [
        {
          selector: '.car-number-item', // 选择器
        },
        {
          selector: '.button', // 选择器
        },
      ],
      addEventListener: true,
      formWidth: '',
    }
  },
  computed: {
    getMarginNumber() {
      return -(this.options.boxMargin + 4 + 2) / 2 + 'px'
    },
    getLastOptions() {
      return this.isArea ? this.areaBottomOptions : this.areaLetterOptions3
    },
    lastText() {
      return this.getCarNumber[7] !== '' ? this.getCarNumber[7] : '新能源'
    },
    getSelectBorderColor() {
      return this.options.selectBorderColor
    },
  },
  watch: {
    visible() {
      const form = document.getElementsByClassName('el-form-drawer-bind')
      if (!this.visible) {
        form[0].style.paddingBottom = '0px'

        // let str = ''
        // this.getCarNumber.forEach(item => {
        //   if (item) str += item
        // })
        // this.$emit('update:value', str)
      } else {
        if (form.length > 0) {
          form[0].style.paddingBottom = '200px'
        }
      }
    },
    getCarNumber: {
      handler() {
        let str = ''
        this.getCarNumber.forEach(item => {
          if (item) str += item
        })
        this.$emit('update:value', str)
      },
      immediate: true,
      deep: true,
    },
    disabled() {
      this.current = !this.disabled ? 0 : -1
    },
  },
  mounted() {
    const form = document.getElementsByClassName('el-form-drawer-bind')
    if (form.length > 0) {
      this.formWidth = form[0].clientWidth + 20
    }

    window.addEventListener('resize', () => {
      this.formWidth = form[0].clientWidth + 20
    })

    window.addEventListener(
      'click',
      e => {
        const el = this.getTargetDomByPointerEvent(e)
        if (!el) return
        this.addEventListener = true
        const className = el.className.split(' ')

        if (className.indexOf('add-event-listener') > -1) {
          this.addEventListener = false
        }

        if (this.globalClickListeners.length && this.addEventListener) {
          this.globalClickListeners.forEach(({ selector }) => {
            if (selector) {
              // 选择器的情况
              const els = document.querySelectorAll(selector)
              // 点击元素是否包含所属选择器范围
              const isIncludes = [...els].includes(el)
              if (!isIncludes) {
                this.visible = false
              }
              // 包含则上报
              // if (isIncludes) {
              //   const detail = this.htmlElementAsString(el)
              // }
            }
          })
        }
      },
      true
    )

    // 初始化
    if (this.value === '') {
      this.getCarNumber = ['', '', '', '', '', '', '', '']
      this.current = 0
    } else {
      this.getCarNumber = this.value.split('')
      let str = ''
      this.getCarNumber.forEach(item => {
        str += item
      })
      const number = 8 - this.getCarNumber.length
      for (let i = 0; i < number; i++) {
        this.getCarNumber.push('')
      }
      this.current = str.length
    }
  },
  methods: {
    // 通过坐标计算目标元素
    getTargetDomByPointerEvent(e) {
      const el = document.elementFromPoint(e.pageX, e.pageY)
      if (el) {
        return el
      }

      return null
    },
    // 解析函数
    htmlElementAsString(target) {
      const tagName = target.tagName.toLowerCase()
      if (tagName === 'body') {
        return ''
      }
      let classNames = target.classList.value

      classNames = classNames !== '' ? ` class='${classNames}'` : ''
      const id = target.id ? ` id="${target.id}"` : ''
      const innerText = target.innerText
      return `<${tagName}${id}${
        classNames !== '' ? classNames : ''
      }>${innerText}</${tagName}>`
    },
    // 键盘按钮选中事件
    handleSelect(val) {
      if (['O', 'I'].indexOf(val) > -1) {
        return false
      }
      if (this.current == 8) {
        this.$set(this.getCarNumber, this.current - 1, val)
      }
      if (this.current < 8) {
        this.$set(this.getCarNumber, this.current, val)
        this.isArea = false
        this.current++
      }
    },
    // 重置
    handleReset() {
      this.isArea = true
      this.current = 0
      this.getCarNumber = ['', '', '', '', '', '', '', '']
    },
    // 关闭
    handleClose() {
      this.visible = false
    },
    // 删除
    handleDelete() {
      if (this.current == 0) {
        this.isArea = true
        this.$set(this.getCarNumber, 0, '')
      }

      if (this.current > 0) {
        this.$set(
          this.getCarNumber,
          this.current == 8 ? this.current - 1 : this.current,
          ''
        )
        this.current--
        if (this.current == 0) {
          this.isArea = true
        }
      }
    },
    handleToggle(index) {
      if (!this.disabled) {
        const keyboardContainerDom =
          document.getElementsByClassName('keyboard-container')
        for (let i = 0; i < keyboardContainerDom.length; i++) {
          keyboardContainerDom[i].style.display = 'none'
        }
        this.$refs[`keyboardRef${this.model}`].style.display = 'block'
        // const keyboardContainerDom =
        //   document.getElementsByClassName('keyboard-container')
        // if (keyboardContainerDom.length > 0) {
        //   for (let i = 0; i < keyboardContainerDom.length; i++) {
        //     keyboardContainerDom[i].style.display = 'none'
        //   }
        // }

        // if (
        //   this.$refs[`keyboardRef${this.model}`] &&
        //   this.$refs[`keyboardRef${this.model}`].$el &&
        //   this.$refs[`keyboardRef${this.model}`].$el.style
        // ) {
        //   this.$refs[`keyboardRef${this.model}`].$el.style.display = 'block'
        // }
        this.$nextTick(() => {
          this.visible = true
          this.current = index
          this.isArea = this.current == 0
        })
      }
    },
    getStyle(index, current) {
      const {
        boxWidth,
        boxHeight,
        boxMargin,
        borderRadius,
        textSize,
        textColor,
        borderColor,
        backgroundColor,
        newEnergyFontSize,
        newEnergyColor,
        selectBorderColor,
        theme,
      } = this.options
      let style = {
        width: boxWidth + 'px',
        height: boxHeight + 'px',
        margin: `0 ${boxMargin}px 0 0`,
        'font-size': `${index === 7 ? newEnergyFontSize : textSize}px`,
        color: index === 7 ? newEnergyColor : textColor,
        'background-color': backgroundColor,
      }
      if (theme === 'block') {
        style = {
          ...style,
          'border-radius': borderRadius,
          border: `1px solid ${
            index === 7
              ? newEnergyColor
              : index === current
                ? selectBorderColor
                : borderColor
          }`,
        }
      }
      return style
    },
    getContainerStyle() {
      const { borderColor, theme, backgroundColor } = this.options
      let style = {
        width: 'fit-content',
        border: `1px solid ${borderColor}`,
        'background-color': backgroundColor,
      }
      return theme === 'line' ? style : ''
    },
  },
}
</script>
<style lang="scss" scoped>
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.car-number-container {
  // position: relative;
  .car-number-list {
    display: flex;
    .car-number-item {
      display: flex;
      align-items: center;
      justify-content: center;
      &.line {
        position: relative;
        &:after {
          content: '';
          width: 1px;
          height: 50%;
          position: absolute;
          right: 0;
          top: 25%;
          background-color: #d9d9d9;
          -webkit-transform: scaleX(0.5);
          transform: scaleX(0.5);
        }
        &:last-child {
          &:after {
            display: none;
          }
        }
        &:nth-child(3) {
          &::before {
            display: none;
          }
        }
      }

      &:nth-child(3) {
        position: relative;
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: v-bind(getSelectBorderColor);
          margin: auto;
          left: v-bind(getMarginNumber);
        }
      }
    }
  }

  .keyboard-container {
    background: rgb(208, 211, 220);
    position: fixed;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: 0px auto;
    z-index: 1001;
    // position: absolute;
    // width: 60%;
    // height: 250px;
    // background: #d0d3dc;
    // top: 45px;
    // z-index: 100;

    .el-header {
      padding: 0 15px;
      height: 40px !important;
      line-height: 40px !important;
      display: flex;
      justify-content: space-between;
      // background: #f0f0f0;
    }

    .keyboard-body {
      padding: 5px 5px 15px 5px;
      box-sizing: border-box;

      .button {
        cursor: pointer;
        text-align: center;
        line-height: 40px;
        height: 40px;
        border-radius: 5px;
        background: #fff;
        color: #000;
        margin-bottom: 7px;
        &:active:not(.disabled) {
          background: #cdcdcd;
        }
        &.disabled {
          cursor: not-allowed;
          color: #a8abb2;
        }
      }

      .other-button {
        cursor: pointer;
        width: 5vw;
        height: 40px;
        background: #a8b0bd;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        color: #000;
        &:active {
          background: #cdcdcd;
        }
      }

      .keyboard-body-province-list {
        column-gap: 5px;
        margin: 0;
        padding: 0;
      }

      .keyboard-body-bottom {
        display: flex;
        justify-content: space-between;

        .keyboard-body-bottom-item-list {
          width: 100%;
          margin: 0;
          padding: 0 5px;
          list-style: none;
          column-gap: 5px;
        }
      }
    }
  }
}
</style>
